export const tr = {
    emptyMessage: 'Değer girin',
    gteCpmBannerMessage: 'Teklif maksimum {maxValue} olabilir',
    gteCpmBannerMessageWithCurrency: 'Teklif maksimum {maxValue} {currency} olabilir',
    gteMessage: 'Tıklama başına fiyat mümkün olan en yüksek değerin {maxValue} üzerinde',
    gteMessageWithCurrency: 'Tıklama başına fiyat mümkün olan en yüksek değerin {maxValue} {currency} üzerinde ',
    lteCpmBannerMessage: 'Teklif minimum {misValue} olabilir',
    lteCpmBannerMessageWithCurrency: 'Teklif minimum {minValue} {currency} olabilir',
    lteMessage: 'Tıklama başına fiyat mümkün olan en düşük değerin {minValue} altında',
    lteMessageWithCurrency: 'Tıklama başına fiyat mümkün olan en düşük değerin {minValue} {currency} altında',
    nanCpmBannerMessage: 'Teklif sayı olmalıdır',
    nanMessage: 'Tıklama başına fiyat sayı olmalıdır'
};
